export enum LanguageAbbreviation {
    pl = 'pl',
    en = 'en'
}
